// extracted by mini-css-extract-plugin
export default {"root":"Phone_root__sMasM","img":"Phone_img__n5C93"};